import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../../api';
import { SHOW_COMING_SOON, SHOW_PREMIERE_RSVP } from '../../config';
import "./Header.css";

export default function Header({ onOpenRSVP }) {
    const [user, setUser] = useState(null);
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        const storedUser = localStorage.getItem('user');
        const storedToken = localStorage.getItem('token');
        if (storedUser && storedToken) {
            try {
                setUser(JSON.parse(storedUser));
            } catch (e) {
                console.error("Error parsing stored user data:", e);
            }

            // Sync with backend profile to get latest subscription state
            const syncProfile = async () => {
                try {
                    const response = await api.get('auth/profile/');
                    const updatedUser = response.data;
                    localStorage.setItem('user', JSON.stringify(updatedUser));
                    setUser(updatedUser);
                } catch (err) {
                    console.error("Failed to sync profile:", err);
                }
            };
            syncProfile();
        }
    }, []);

    const handleLogout = async (e) => {
        e.preventDefault();
        try {
            await api.post('auth/logout/');
        } catch (err) {
            console.error("Logout API error:", err);
        }
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        setUser(null);
        navigate('/');
    };

    const toggleMenu = () => {
        setIsMenuOpen(!isMenuOpen);
    };

    return (
        <header className="glass-header">
            <div className="header-left">
                <a href="/">
                    <img src="/assets/GAWAH_logo.png" alt="GAWAH Media" className="logo-img" />
                </a>
            </div>

            <button className={`hamburger-btn ${isMenuOpen ? 'open' : ''}`} onClick={toggleMenu} aria-label="Toggle menu">
                <span className="bar"></span>
                <span className="bar"></span>
                <span className="bar"></span>
            </button>

            <div className={`header-menu-container ${isMenuOpen ? 'open' : ''}`}>
                <nav className="header-nav">
                    {SHOW_PREMIERE_RSVP && (
                        <button 
                            className="rsvp-header-link" 
                            onClick={() => { onOpenRSVP && onOpenRSVP(); toggleMenu(); }}
                        >
                            RSVP Premiere
                        </button>
                    )}
                    <a href="/#story" onClick={toggleMenu}>The Story</a>
                    <a href="/#trailer" onClick={toggleMenu}>Trailer</a>
                    <a href="/reviews" onClick={toggleMenu}>Reviews</a>

                    {user && user.is_premium ? (

                        <a href="/watch" className="watch-link-highlight" onClick={toggleMenu}>WATCH</a>
                    ) : (
                        <a href={SHOW_COMING_SOON ? "/coming-soon" : "/#subscribe"} onClick={(e) => { toggleMenu(); if (!SHOW_COMING_SOON) { const el = document.getElementById('subscribe'); if (el) { e.preventDefault(); el.scrollIntoView({ behavior: 'smooth' }); } } }}>Subscribe</a>
                    )}
                    <a href="/contact" onClick={toggleMenu}>Contact Us</a>
                </nav>

                <div className="header-right">
                    {user ? (
                        <div className="user-session-info">
                            <a href="/profile" className="user-greeting" onClick={toggleMenu} style={{textDecoration: 'none'}}>
                                Hello, {user.first_name || user.email}
                            </a>
                            <a href="#logout" onClick={(e) => { handleLogout(e); toggleMenu(); }} className="logout-btn">Logout</a>
                        </div>
                    ) : (
                        <div className="header-actions-right">
                            <a href={SHOW_COMING_SOON ? "/coming-soon" : "/#subscribe"} className="subscribe-btn-header" onClick={(e) => { toggleMenu(); if (!SHOW_COMING_SOON) { const el = document.getElementById('subscribe'); if (el) { e.preventDefault(); el.scrollIntoView({ behavior: 'smooth' }); } } }}>Subscribe Now</a>
                            <a href="/login" className="login-btn" onClick={toggleMenu}>Login</a>
                        </div>
                    )}
                </div>
            </div>
        </header>
    );
}
